import React from 'react';

const PanelUserSvg = ({ className }) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
          className={className}
    >
      <path
        d="M5.25 6H3C2.175 6 1.5 5.325 1.5 4.5V3C1.5 2.175 2.175 1.5 3 1.5H5.25C6.075 1.5 6.75 2.175 6.75 3V4.5C6.75 5.325 6.075 6 5.25 6Z"
        stroke="#2D3748"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6 5.25H12.9C12.405 5.25 12 4.84499 12 4.34999V3.15001C12 2.65501 12.405 2.25 12.9 2.25H15.6C16.095 2.25 16.5 2.65501 16.5 3.15001V4.34999C16.5 4.84499 16.095 5.25 15.6 5.25Z"
        stroke="#2D3748"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6 10.875H12.9C12.405 10.875 12 10.47 12 9.97499V8.77501C12 8.28001 12.405 7.875 12.9 7.875H15.6C16.095 7.875 16.5 8.28001 16.5 8.77501V9.97499C16.5 10.47 16.095 10.875 15.6 10.875Z"
        stroke="#2D3748"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.75 3.75H12"
        stroke="#2D3748"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.375 3.75V13.5C9.375 14.325 10.05 15 10.875 15H12"
        stroke="#2D3748"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.375 9.375H12"
        stroke="#2D3748"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.6 16.5H12.9C12.405 16.5 12 16.095 12 15.6V14.4C12 13.905 12.405 13.5 12.9 13.5H15.6C16.095 13.5 16.5 13.905 16.5 14.4V15.6C16.5 16.095 16.095 16.5 15.6 16.5Z"
        stroke="#2D3748"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default PanelUserSvg;
